module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAASCAYAAABM8m7ZAAAABHNCSVQICAgIfAhkiAAAANNJREFUSIm1lT0KAjEQhQNb7gFyhT3FXmOvokex8xJWnkDQRrBRBAtrwVILPwtnMQ64ZPIzZSa8L5m8RxywBfaAd5UL8MAB2DjgxKd2QFsR2soFAY4O6IC7LKyApgK0AdbCuAHd2OiBpzQWFcBL0X4AvW4OfGtWEDoXzRcwpG+yQeMvMzkWG9T2fH+NYIOmGVZZ/2LJuGT1mhzRFIGcA2uh6JGVeCItGGWSUqbUopOxKB3DKHFTVjPgP+M0ZzUDHBoorCqfi4aHkUnLagbcA+ecrL4B+k0RfseEqacAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/openMenu.png
// module id = EbZJ
// module chunks = 1